export function formatDate(dateStr, options = {}) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  }
  return date.toLocaleString('zh-CN', defaultOptions)
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '-'
  const date = new Date(dateStr)
  return date.toLocaleDateString('zh-CN')
}

export default {
  formatDate,
  formatDateShort
}
